import { render } from "./CriticalSignalPopup.vue?vue&type=template&id=4f465d90"
import script from "./CriticalSignalPopup.js?vue&type=script&lang=js"
export * from "./CriticalSignalPopup.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__